module.exports = __webpack_public_path__ + "img/innisfree2.025dac42.jpg";